<script>
    import R, {LOADER} from "../lib/requests";
    import charges from "../stores/charges";
    import {humanDate} from "../lib/lib";
    import A from "../lib/Router/A.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import ServiceEditModal from "../services/ServiceEditModal.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import ServiceColorName from "../components/controls/ServiceColorName.svelte";
    import SubscriptionEditModal from "../services/SubscriptionEditModal.svelte";
    import ChargeObject from "../components/controls/ChargeObject.svelte";
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";


    let expiredServices = [];
    let expiringServices = [];
    let pendingCharges = [];
    let notifications = 0;
    let editServiceId = null;
    let renewServiceId = null;

    const load = (loader = LOADER.PAGE) => {
        const onSuccess = result => {
            expiredServices = result.expired_services;
            expiringServices = result.expiring_services;
            pendingCharges = result.charges;
            notifications = ~~result.notifications;

            pendingCharges.map(item => {
                if (item.payment) {
                    item.balance = (parseFloat(item.price) - parseFloat(item.payment)).toFixed(2);
                } else {
                    item.balance = item.price;
                }
            });
        }

        const onFailure = err => {
        };

        R.handle(R.workspace.dashboard, [], onSuccess, onFailure, loader);
    };

    const editService = id => {
        editServiceId = id;
    }

    const closeEdit = param => {
        editServiceId = null;
        if (param) {
            load(LOADER.POPUP);
        }
    }

    const renewService = id => {
        renewServiceId = id;
    }


    const closeRenew = (param) => {
        renewServiceId = null;
        if (param) {
            load(LOADER.POPUP);
        }
    }

    const editCharge = id => {
        charges.edit(id, closeCharge)
    }

    const closeCharge = param => {
        if (param) {
            load(LOADER.POPUP);
        }
    }

    load();
</script>

<PageHeader title="Dashboard" on:reload={load}/>

{#if expiredServices.length}
    <table class="table table-list mb-5">
        <thead>
        <tr>
            <th colspan="3" class="heading">
                ΕΛΗΞΑΝ
            </th>
        </tr>
        </thead>
        <tbody>
        {#each expiredServices as service}
            <tr>
                <td>
                    <button class="btn-reset is-link" on:click={ () => editService(service.id) }>
                        <ServiceColorName {service}/>
                    </button>
                </td>
                <td class="date-column text-gray text-end">
                    { humanDate(service.expires_at, true) }
                </td>
                <td class="button-column">
                    <button class="btn btn-link" title="ανανέωση" on:click="{ () => renewService(service.id) }">
                        <AppIcon icon="renew" strokeWidth="2"/>
                    </button>
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
{/if}

{#if expiringServices.length}
    <table class="table table-list mb-5">
        <thead>
        <tr>
            <th colspan="3" class="heading">
                ΛΗΓΟΥΝ ΣΥΝΤΟΜΑ
            </th>
        </tr>
        </thead>
        <tbody>
        {#each expiringServices as service}
            <tr>
                <td>
                    <button class="btn-reset is-link" on:click={ () => editService(service.id) }>
                        <ServiceColorName {service}/>
                    </button>
                </td>
                <td class="date-column text-gray text-end">
                    { humanDate(service.expires_at, true) }
                </td>
                <td class="button-column">
                    <button class="btn btn-link" title="ανανέωση" on:click="{ () => renewService(service.id) }">
                        <AppIcon icon="renew" strokeWidth="2"/>
                    </button>
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
{/if}

{#if pendingCharges.length}
    <table class="table table-list mb-4">
        <tr>
            <th class="heading" colspan="3">
                ΕΚΚΡΕΜΕΙΣ ΧΡΕΩΣΕΙΣ
            </th>
            <th class="heading">
                ΥΠΟΛΟΙΠΟ
            </th>
        </tr>
        <tbody>
        {#each pendingCharges as item}
            <tr>
                <td>
                    <button class="btn-reset is-link" on:click={ () => editCharge(item.id) }>
                        { item.name }
                    </button>
                </td>
                <td class="text-gray">
                    <ChargeObject object="{ item.object }"/>
                </td>
                <td class="text-gray">
                    {#if item.client}
                        {item.client.name}
                    {:else if item.project}
                        <ColoredNameControl name={item.project.name} color={item.project.color}/>
                    {/if}
                </td>
                <td class="text-gray price-column text-end">
                    { item.balance }
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
{/if}

{#if notifications > 0}
    <div class="panel-simple panel-pad mb-4">
        Υπάρχουν <A href="/app/notifications">{ notifications } ειδοποιήσεις</A> προς αποστολή.
    </div>
{/if}

{#if editServiceId}
    <ServiceEditModal serviceId="{editServiceId}" closeCallback="{closeEdit}"/>
{/if}
{#if renewServiceId != null}
    <SubscriptionEditModal serviceId="{ renewServiceId }" closeCallback="{ closeRenew }"/>
{/if}
